import React from "react";

const ErrorPageMain: React.FC = () => {
    return (
        <div className="error_page_container">
            <div className="error_page_area">
                <img src="/assets/images/error/error.svg"
                    className="mb-4" alt="Something went wrong"
                    style={{ width: '55%', height: '55%' }} />
                <h3>Something went wrong</h3>
                <p>Please try again later.</p>
            </div>
        </div>
    )
}

export default ErrorPageMain;